import * as checked from 'reporting-data/lib/checked';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import { PIVOT } from '../../constants/visualizationTypes';
export const Pivot = checked.record({
  dataset: checked.string(),
  field: checked.string(),
  value: checked.string().optional(),
  groupby: checked.list(checked.string()).optional(),
  op: checked.string().optional()
}, 'Pivot');
export const Style = checked.record({}, 'Style');
export const Events = checked.record({}, 'Events');
export const PivotVisualization = checked.record({
  type: checked.string().always(PIVOT),
  data: checked.map(Dataset),
  pivot: Pivot,
  footer: checked.string().optional(),
  pages: checked.number().optional(),
  onClick: checked.func().optional(),
  style: Style.optional(),
  events: Events.optional(),
  showTotalsColumn: checked.boolean().optional(),
  showTotals: checked.boolean().optional()
}, 'PivotVisualization');